import {
  Comment,
  Fragment,
  Slot,
  Text,
  VNode,
} from 'vue';

// from: https://github.com/vuejs/core/issues/4733#issuecomment-1024816095
export function hasSlotContent(slot: Slot | undefined, slotProps = {}): boolean {
  if (!slot) {
    return false;
  }

  return slot(slotProps).some((vnode: VNode) => {
    if (vnode.type === Comment) {
      return false;
    }

    if (Array.isArray(vnode.children) && !vnode.children.length) {
      return false;
    }

    return (
      vnode.type !== Text
      || (typeof vnode.children === 'string' && vnode.children.trim() !== '')
    );
  });
}

/**
 * The elements rendered by a slot, one per child the caller placed into it. Fragments, e.g. of a
 * `v-for`, are unpacked; placeholders of a false `v-if` and whitespace are left out.
 */
export function getSlotChildren(vnodes: VNode[]): VNode[] {
  return vnodes.flatMap((vnode) => {
    if (vnode.type === Fragment && Array.isArray(vnode.children)) {
      return getSlotChildren(vnode.children as VNode[]);
    }
    if (vnode.type === Comment) {
      return [];
    }
    if (vnode.type === Text && (typeof vnode.children !== 'string' || vnode.children.trim() === '')) {
      return [];
    }
    return [
      vnode,
    ];
  });
}
